// window.addEventListener("DOMContentLoaded", () => {
//   function languageHandler(e) {
//     const currencySelect = document.querySelector(".top-header__lan-select");
//     const localizationForm = currencySelect?.closest("form");
//     const selectedValue = e.target.value.toUpperCase();
//     const select = document.querySelector(".top-header__curr-select");
//     Array.from(select.options).forEach(option => {
//       option.selected = false; // Unselect all
//     });

//     let matched = false;

//     Array.from(select.options).forEach(option => {
//       if (option.value === selectedValue) {
//         option.selected = true;
//         matched = true;
//         localizationForm.submit();
//       }
//     });

//     if (!matched && selectedValue === 'EN') {
//       const defaultOption = Array.from(select.options).find(option => option.value === 'IE');
//       if (defaultOption) {
//         defaultOption.selected = true;
//         localizationForm.submit();
//       }
//     }

//     // when language change then change url path start here
//     const selectedLang = e.target.value;
//     const origin = window.location.origin;
//     const path = window.location.pathname;

//     const isCollectionPage = path.includes('/collections/');

//     if (isCollectionPage) {
//       const targetPath = '/collections/all';
//       const newUrl = selectedLang === 'en'
//         ? `${origin}${targetPath}`
//         : `${origin}/${selectedLang}${targetPath}`;

//       window.location.href = newUrl;
//     } 

//     // else {
//     //   const cleanedPath = path.replace(/^\/(de|en)(\/|$)/, '/');
//     //   const newPath = selectedLang === 'en' ? cleanedPath : `/${selectedLang}${cleanedPath}`;
//     //   window.location.href = `${origin}${newPath}`;
//     // }
//   // when language change then change url path end here

//   }

//   document.querySelectorAll(".top-header__lan-select").forEach((elm) => {
//     elm.addEventListener("change", languageHandler);
//   });
// });




// working good code when user own country 








// $(document).ready(function () {
//   const $videoSection = $('.comfort__inner');
//   const $video = $videoSection.find('video').get(0);

//   if (!$video) {
//     console.warn("Video element not found inside .comfort__inner");
//     return;
//   }

//   function checkVisibility() {
//     const sectionTop = $videoSection.offset().top;
//     const sectionBottom = sectionTop + $videoSection.outerHeight();
//     const scrollTop = $(window).scrollTop();
//     const windowHeight = $(window).height();

//     const isVisible = sectionBottom > scrollTop && sectionTop < (scrollTop + windowHeight);

//     if (isVisible) {
//       $video.play().catch(err => console.warn("Autoplay failed:", err));
//     } else {
//       $video.pause();
//     }
//   }

//   // Check initially and on scroll/resize
//   $(window).on('load scroll resize', checkVisibility);
// });



// document.addEventListener("DOMContentLoaded", function () {
//   const video = document.querySelector(".comfort__inner video");

//   if (!video) return;

//   const observer = new IntersectionObserver((entries) => {
//     entries.forEach(entry => {
//       if (entry.isIntersecting) {
//         video.play().catch(err => console.warn("Autoplay failed:", err));
//       } else {
//         video.pause();
//       }
//     });
//   }, {
//     threshold: 0.5
//   });

//   observer.observe(document.querySelector(".comfort__inner"));
// });





// document.addEventListener("DOMContentLoaded", function () {
//   const section = document.querySelector(".comfort__inner");
//   if (!section) return;

//   const video = section.querySelector("video");
//   const iframe = section.querySelector("iframe");

//   // === Native <video> autoplay logic ===
//   if (video) {
//     video.muted = true;
//     video.playsInline = true;
//     video.removeAttribute("controls");

//     const observer = new IntersectionObserver((entries) => {
//       entries.forEach(entry => {
//         if (entry.isIntersecting) {
//           video.play().catch(err => console.warn("Video play failed", err));
//         } else {
//           video.pause();
//         }
//       });
//     }, { threshold: 0.5 });

//     observer.observe(video);
//   }

//   // === YouTube <iframe> autoplay logic ===
//   if (iframe && iframe.src.includes("youtube.com/embed")) {
//     // Modify the src to ensure JS API and autoplay params
//     const url = new URL(iframe.src);

//     url.searchParams.set("enablejsapi", "1");
//     url.searchParams.set("autoplay", "1");
//     url.searchParams.set("mute", "1"); // required for autoplay on mobile
//     url.searchParams.set("loop", "1"); // required for autoplay on mobile

//     // Replace src with updated parameters
//     iframe.src = url.toString();

//     // Load YouTube Iframe API if needed
//     if (!window.YT || typeof YT.Player !== "function") {
//       const tag = document.createElement("script");
//       tag.src = "https://www.youtube.com/iframe_api";
//       document.head.appendChild(tag);
//     }

//     // Wait for the YouTube API to be ready
//     window.onYouTubeIframeAPIReady = function () {
//       const player = new YT.Player(iframe, {
//         events: {
//           onReady: () => {
//             // Observe visibility and autoplay/pause based on it
//             const observer = new IntersectionObserver((entries) => {
//               entries.forEach(entry => {
//                 if (entry.isIntersecting) {
//                   player.playVideo();
//                 } else {
//                   player.pauseVideo();
//                 }
//               });
//             }, { threshold: 0.5 });

//             observer.observe(section);
//           }
//         }
//       });
//     };
//   }
// });


document.addEventListener("DOMContentLoaded", function () {
  const section = document.querySelector(".comfort__inner");
  if (!section) return;

  const video = section.querySelector("video");
  const iframe = section.querySelector("iframe");

  // === Native <video> autoplay logic ===
  if (video) {
    video.muted = true;
    video.playsInline = true;
    video.removeAttribute("controls");

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          video.play().catch(err => console.warn("Video play failed", err));
        } else {
          video.pause();
        }
      });
    }, {
      threshold: 0.5
    });

    observer.observe(video);
  }

  // === YouTube <iframe> autoplay + loop logic ===
  if (iframe && iframe.src.includes("youtube.com/embed")) {
    const originalUrl = new URL(iframe.src);
    const videoId = originalUrl.pathname.split("/").pop();

    originalUrl.searchParams.set("enablejsapi", "1");
    originalUrl.searchParams.set("autoplay", "1");
    originalUrl.searchParams.set("mute", "1");
    originalUrl.searchParams.set("loop", "1");
    originalUrl.searchParams.set("playlist", videoId);

    iframe.src = originalUrl.toString();

    // Load YT API if not loaded
    if (!window.YT || typeof YT.Player !== "function") {
      const tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";
      document.head.appendChild(tag);
    }

    window.onYouTubeIframeAPIReady = function () {
      const player = new YT.Player(iframe, {
        events: {
          onReady: () => {
            const observer = new IntersectionObserver((entries) => {
              entries.forEach(entry => {
                if (entry.isIntersecting) {
                  player.playVideo();
                } else {
                  player.pauseVideo();
                }
              });
            }, {
              threshold: 0.5
            });

            observer.observe(section);
          }
        }
      });
    };
  }
});



var Shopify = Shopify || {};
Shopify.queryParams = {};


function applyFiltersFromURL() {
  let queryParams = new URLSearchParams(window.location.search);

  $(".collection-filters__form input[type=checkbox], .collection-filters__form input[type=radio]").each(function () {
    let filterKey = $(this).attr("name");
    let filterValue = $(this).val();

    if (queryParams.has(filterKey)) {
      let selectedFilters = queryParams.getAll(filterKey);

      if (selectedFilters.includes(filterValue)) {
        $(this).prop("checked", true);
      }
    }
  });

  let sortQuery = queryParams.get("sort_by");

  if (sortQuery) {
    $(".collection-filters__sort-by").each(function () {
      let sortByAttr = $(this).attr("data-src");
      let sortByText = $(this).text().trim();

      if (sortByAttr == sortQuery) {
        $(".collection-filters__select-title h4").text(sortByText);
        $(".collection-filters__sort-title p").text(sortByText);

      }
    });

  }

}
applyFiltersFromURL();


function updateCollectionProducts() {
  let currentUrl = window.location.pathname;
  let queryParams = new URLSearchParams();


  $(".collection-filters__form input[type=checkbox]:checked, .collection-filters__form input[type=radio]:checked").each(function () {
    let filterKey = $(this).attr("name");
    let filterValue = $(this).val();
    queryParams.append(filterKey, filterValue);
  });


  if (Shopify.queryParams.sort_by) {
    queryParams.set("sort_by", Shopify.queryParams.sort_by);

  }

  let sortQuery = queryParams.get("sort_by");

  if (sortQuery) {
    $(".collection-filters__sort-by").each(function () {
      let sortByAttr = $(this).attr("data-src");
      let sortByText = $(this).text().trim();

      if (sortByAttr == sortQuery) {
        $(".collection-filters__select-title h4").text(sortByText);
        $(".collection-filters__sort-title p").text(sortByText);

      }
    });
  } else {
    $(".collection-filters__select-title h4").text('Best Selling');
    $(".collection-filters__sort-title p").text('Best Selling');
  }

  let updatedUrl = `${currentUrl}?${queryParams.toString()}`;

  fetch("?section_id=main-collection&" + queryParams.toString())
    .then(res => res.text())
    .then(data => {
      var col = $(data);
      var card = $(".collection-filters__product-wrap", col);
      $(".collection-filters__product-wrap").replaceWith(card);

      // change button and badge text 


      let textContainer = document.getElementById("collection-badge-and-button-text");
      let btnText = textContainer.getAttribute("data-btn-text");
      let badgeText = textContainer.getAttribute("data-badge-text");

      $(".collection-filters__product-btn .btn-common").text(btnText);
      $(".collection-filters__product-img-top-left-text span").text(badgeText);
      $(".collection-filters__product-price-save span").text(badgeText);

      // change button and badge text 


      let hasProducts = card.find(".collection-filters__product-item-item").length > 0;
      if (!hasProducts) {
        $(".collection-filters__product-not-found").show();

      } else {
        $(".collection-filters__product-not-found").hide();
      }
    });

  window.history.pushState({
    updatedUrl
  }, '', updatedUrl);
}

$(".collection-filters__form input[type=checkbox], .collection-filters__form input[type=radio]").on("change", function () {
  updateCollectionProducts();

});


// filter collection base 

function updateCollectionURL(handle) {
  let currentUrl = window.location.href;
  let queryString = currentUrl.includes('?') ? currentUrl.split('?')[1] : '';

  let updatedPath = `/collections/${handle}`;
  let updatedUrl = queryString ? `${updatedPath}?${queryString}` : updatedPath;

  let fetchUrl = `${updatedPath}?section_id=main-collection`;
  if (queryString) {
    fetchUrl += `&${queryString}`;
  }

  fetch(fetchUrl)
    .then(res => res.text())
    .then(data => {
      let col = $(data);
      let card = $(".collection-filters__product-wrap", col);
      $(".collection-filters__product-wrap").replaceWith(card);

      // change button and badge text 


      let textContainer = document.getElementById("collection-badge-and-button-text");
      let btnText = textContainer.getAttribute("data-btn-text");
      let badgeText = textContainer.getAttribute("data-badge-text");

      $(".collection-filters__product-btn .btn-common").text(btnText);
      $(".collection-filters__product-img-top-left-text span").text(badgeText);
      $(".collection-filters__product-price-save span").text(badgeText);

      // change button and badge text 



      let hasProducts = card.find(".collection-filters__product-item-item").length > 0;
      if (!hasProducts) {
        $(".collection-filters__product-not-found").show();
      } else {
        $(".collection-filters__product-not-found").hide();
      }

      window.history.pushState({
        updatedUrl
      }, '', updatedUrl);
    });
}

// Handle radio button change
let lastSelectedHandle = null;

$(".collection-filters__collections input[type=radio]").on("click", function () {
  let currentHandle = $(this).val();

  if (lastSelectedHandle === currentHandle) {
    // Uncheck radio and reset to "all"
    $(this).prop("checked", false);
    lastSelectedHandle = null;
    updateCollectionURL("all");
  } else {
    // Normal selection
    lastSelectedHandle = currentHandle;
    updateCollectionURL(currentHandle);
  }
});















function defaultLoad() {

  let currentUrl = window.location.href;
  let collectionHandle = currentUrl.split('/collections/')[1].split('?')[0];


  $(".collection-filters__collections input[type=radio]").each(function () {

    if ($(this).val() === collectionHandle) {
      console.log('Setting checkbox to checked');
      $(this).prop("checked", true);
      let hasProducts = card.find(".collection-filters__product-item-item").length > 0;
      if (!hasProducts) {
        $(".collection-filters__product-not-found").show();

      }
    }
  });
}



$(document).ready(function () {
  defaultLoad();
});










function sortBy(element) {
  let data = $(element).attr("data-src");
  let selectedText = $(element).text().trim();

  if (!data) {
    console.error("Sort option is missing data-src attribute!");
    return;
  }
  Shopify.queryParams.sort_by = data;

  updateCollectionProducts();

  $(".collection-filters__select-title h4").text(selectedText);
  $(".collection-filters__sort-title p").text(selectedText);
  $(".collection-filters__sort-list").hide();
  $(".collection-filters__sort").hide();
  $(".collection-filters__select").removeClass('active');
  $(".collection-filters__sort-wrap").removeClass('active');
}

// updateCollectionProducts();





// applyFiltersFromURL();






// pagination 

function handlePaginationClick(event, page) {
  event.preventDefault();

  console.log("Navigating to page: " + page);

  updateCollection__products(page);
}

function updateCollection__products(page) {
  let searchParams = new URLSearchParams(Shopify.queryParams).toString();
  let sectionId = "main-collection";
  let pageParam = `page=${page}`;

  if (searchParams) {
    searchParams += `&${pageParam}`;
  } else {
    searchParams = pageParam;
  }
  $.ajax({
    url: `${window.location.pathname}?section_id=${sectionId}&${searchParams}`,
    type: "GET",
    success: function (data) {
      let newContent = $(data).find(".collection-filters__product-wrap");

      if (newContent.length) {
        $(".collection-filters__product-wrap").html(newContent.html());
        // change button and badge text 


        let textContainer = document.getElementById("collection-badge-and-button-text");
        let btnText = textContainer.getAttribute("data-btn-text");
        let badgeText = textContainer.getAttribute("data-badge-text");

        $(".collection-filters__product-btn .btn-common").text(btnText);
        $(".collection-filters__product-img-top-left-text span").text(badgeText);
        $(".collection-filters__product-price-save span").text(badgeText);

        // change button and badge text 
      }

      // Update active pagination links
      $(".collection-filters__numbers a").removeClass("active");
      $('.collection-filters__numbers a[data-page="' + page + '"]').addClass("active");
    },
    error: function () {
      console.error("Error fetching section.");
    }
  });


  let updateUrl = `${window.location.pathname}?${searchParams}`;
  window.history.pushState({
    path: updateUrl
  }, '', updateUrl);
}






function handlePaginationClickSearch(event, page) {
  event.preventDefault();
  updateCollection__products_search(page);
}

function updateCollection__products_search(page) {
  let sectionId = "main-search";
  let searchParams = new URLSearchParams(window.location.search);
  searchParams.set("page", page);

  $.ajax({
    url: `${window.location.pathname}?section_id=${sectionId}&${searchParams.toString()}`,
    type: "GET",
    success: function (data) {
      let newContent = $(data).find(`.collection-filters__product-wrap`).html();
      if (newContent) {
        $(".collection-filters__product-wrap").html(newContent);
        // change button and badge text 


        let textContainer = document.getElementById("collection-badge-and-button-text");
        let btnText = textContainer.getAttribute("data-btn-text");
        let badgeText = textContainer.getAttribute("data-badge-text");

        $(".collection-filters__product-btn .btn-common").text(btnText);
        $(".collection-filters__product-img-top-left-text span").text(badgeText);
        $(".collection-filters__product-price-save span").text(badgeText);

        // change button and badge text 

      } else {
        console.warn("No product content found.");
      }

      // Update active pagination
      $(".collection-filters__numbers a").removeClass("active");
      $(`.collection-filters__numbers a[data-page="${page}"]`).addClass("active");
    },
    error: function () {
      console.error("Failed to fetch products via AJAX.");
    }
  });

  let newUrl = `${window.location.pathname}?${searchParams.toString()}`;
  window.history.pushState({
    path: newUrl
  }, '', newUrl);
}


// Blog section
if ($(Window).width() < 768) {
  $('.latest__items , .recommended__items , .related-collection__items').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true
  });
}

$('.latest__left-arrow , .recommended__left-arrow , .related-collection__left-arrow').click(function () {
  $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.latest__right-arrow , .recommended__right-arrow , .related-collection__right-arrow').click(function () {
  $(this).parent().parent().find('.slick-slider').slick('slickNext');
});